import { render, staticRenderFns } from "./DeliveryLoadHistory.vue?vue&type=template&id=42d8086d&scoped=true&"
import script from "./DeliveryLoadHistory.vue?vue&type=script&lang=js&"
export * from "./DeliveryLoadHistory.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryLoadHistory.vue?vue&type=style&index=0&id=42d8086d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8086d",
  null
  
)

export default component.exports